/* @flow */

import React from 'react';
import { Card, Icon, Label, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import OctoResourceImage from 'shared/components/OctoResourceImage';
import cx from 'classnames';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  defaultResourceStrategy: ResourceStrategy,
  link: NavigationContentLink,
  layout: string,
};

const isBrokenLink = link => link.page.isArchived;
const isSecuredLink = link => link.page.securityContext === 'require';

const ItemLink = ({ link }) => {
  const secured = isSecuredLink(link);

  const linkClass = cx('ui basic labeled fluid icon button', {
    red: secured,
  });

  const linkIcon = secured ? 'lock' : 'pointing right';

  return (
    <Link to={`/view/${link.page.id}`} className={linkClass}>
      <Icon name={linkIcon} />
      Naviguer
    </Link>
  );
};

const ViewNavigationLinkItem = ({
  defaultResourceStrategy,
  link,
  layout,
}: Props) => (
  <Card>
    {isBrokenLink(link) && (
      <Popup
        trigger={<Label corner="right" color="red" icon="warning" />}
        content="Page archivée"
      />
    )}
    {layout.code !== 'image-only' && <Card.Content header={link.title} />}
    <OctoResourceImage
      strategy={defaultResourceStrategy}
      resource={link.image}
    />
    <Card.Content extra>
      <ItemLink link={link} />
    </Card.Content>
  </Card>
);

export default ViewNavigationLinkItem;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/ViewNavigationLinkItem.js